import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Box from 'common/components/Box';
import Text from 'common/components/Text';
import Image from 'common/components/Image';
import Logo from 'common/components/UIElements/Logo';
import Heading from 'common/components/Heading';
import Container from 'common/components/UI/Container';
import FooterArea, {
  WidgetArea,
  MenuArea,
  Menu,
  MenuItem,
  Copyright,
} from './footer.style';

import Link from 'common/components/Link';
import logoDark from 'common/assets/image/appModern/logo2.png';

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      appJasmineJson {
        footer {
          logo {
            publicURL
          }
          menu {
            id
            link
            text
          }
          widgets {
            id
            icon {
              publicURL
            }
            title
            description
          }
        }
      }
    }
  `);
  const { logo, menu, widgets } = data.appJasmineJson.footer;
  const date = new Date();
  const year = date.getFullYear();

  return (
    <FooterArea>
      <Container>
        <MenuArea>
          <Logo
            className="logo"
            href="#"
            logoSrc={logoDark}
            title="App Classic"
          />
          <Menu>
            {menu.map((item) => (
              <MenuItem key={`footer-link${item.id}`}>
                <a href={item.link}>{item.text}</a>
              </MenuItem>
            ))}
          </Menu>
          <Copyright>
            <p color="rgba(255, 255, 255, 0.5)">
              Desarrollado por:{' '}
              <Link
                color="#92F37F"
                href="https://www.linkedin.com/in/xavier-iv%C3%A1n-aguas-5764b5133/"
              >
                Xavier Aguas
              </Link>
            </p>
          </Copyright>
          <p color="rgba(255, 255, 255, 0.7)" style={{ "font-size": "12px", "color": "white"}}>
            <Link
              color="#466CC8"
              href="/"
            >
              Términos y condiciones
            </Link>
            {/* {' || '}
            <Link
              color="#466CC8"
              href="/"
            >
              Políticas de privacidad
            </Link> */}
          </p>
        </MenuArea>
        {/* End of footer menu area */}
      </Container>
    </FooterArea>
  );
};

export default Footer;
